var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.status == "loading"
          ? _c(
              "div",
              { staticClass: "form__overlay" },
              [_c("spinner-component")],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.status == "success"
          ? _c(
              "div",
              { staticClass: "form__alertSuccess", attrs: { role: "alert" } },
              [
                _c("fa-icon", {
                  staticClass: "mr-05",
                  attrs: { icon: ["fal", "check"] }
                }),
                _vm._v(" " + _vm._s(_vm.successText) + "\n        ")
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.status == "error"
          ? _c(
              "div",
              { staticClass: "form__alertError", attrs: { role: "alert" } },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$helpers.trans("forms.messages.error")) +
                    "\n        "
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "form",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.status == "pending",
                expression: "status == 'pending'"
              }
            ],
            ref: "form",
            staticClass: "form__body",
            attrs: { id: "form" + _vm.name, enctype: "multipart/form-data" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.send()
              }
            }
          },
          [
            _vm._t("default", function() {
              return _vm._l(_vm.formInputs, function(input, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "form-group" },
                  [
                    _c(input.component, {
                      tag: "component",
                      attrs: { input: input }
                    }),
                    _vm._v(" "),
                    ![
                      "checkbox-group",
                      "radio-group",
                      "locationPicker",
                      "file"
                    ].includes(input.type)
                      ? _c(
                          "label",
                          {
                            staticClass: "form-label",
                            attrs: { for: input.name }
                          },
                          [
                            _c("span", { staticClass: "form-label__content" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(input.label) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "bar" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "invalid-feedback" }),
                    _vm._v(" "),
                    input.description
                      ? _c("small", { staticClass: "form-text text-muted" }, [
                          _vm._v(_vm._s(input.description))
                        ])
                      : _vm._e()
                  ],
                  1
                )
              })
            }),
            _vm._v(" "),
            _c("input", {
              staticStyle: { position: "absolute", left: "-9999px" },
              attrs: {
                type: "text",
                name: "fax_number",
                value: "",
                autocomplete: "nope"
              }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "user_identification" },
              domProps: { value: _vm.timehash }
            }),
            _vm._v(" "),
            _vm.type
              ? _c("input", {
                  attrs: { type: "hidden", name: "type" },
                  domProps: { value: _vm.type }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.spamFilter
              ? _c("input", {
                  staticStyle: { position: "absolute", left: "-9999px" },
                  attrs: {
                    type: "text",
                    name: "donotfillthisfield",
                    value: "",
                    autocomplete: "nope"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._t(
              "submit",
              function() {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit" }
                    },
                    [_vm._v(_vm._s(_vm.$helpers.trans("messages.send")))]
                  )
                ]
              },
              { submit: _vm.send }
            )
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-915fa32e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-915fa32e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../default-js/js/components/common/Form.vue
// module id = 209
// module chunks = 17